import { useState, useEffect } from "react";

const contentsMaxWidth = 750;

/**
 * @description windowサイズに応じて、media(video, photo)のサイズを取得する
 */
const useGetMediaSize = ({
  max = contentsMaxWidth,
  ratio = 85,
}: {
  max?: number;
  ratio?: number;
}) => {
  const [mediaSize, setMediaSize] = useState<{ width: number; height: number }>(
    {
      width: 0,
      height: 0,
    },
  );
  useEffect(() => {
    const handleResize = () => {
      const wWidth = window.innerWidth;
      const _width = (wWidth * ratio) / 100;
      const width = _width >= max ? max : _width;
      setMediaSize({
        width,
        height: (width * 9) / 16,
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return {
    ...mediaSize,
  };
};

export default useGetMediaSize;
